import { ApiRoutes } from '@utils/api-routes'
import DialogEmitter from '@utils/emitters/DialogEmitter'
import { GACategory } from '@utils/google-analytics'
import GoogleTagManager from '@utils/gtm/google-tag-manager'
import http from '@utils/http'
import PageRoutes from '@utils/page-routes'

import type { Session } from '@utils/Session'

export default class ScoreService {
  static async createNewScore(session: Session): Promise<void> {
    const [resp, errors] = await http.post(ApiRoutes.members.createScorePath())
    if (resp) {
      GoogleTagManager.trackLegacyEvent(GACategory.BEHAVIOR, 'score_creation')
      window.location.href = PageRoutes.viewScorePath(resp.data.score.external_id)
    } else if (errors) {
      if (
        errors.some((error) => error.code === 'tooManyScores') &&
        !session.current_user?.has_premium_features
      ) {
        DialogEmitter.openDialog('must_be_premium')
      }
    }
  }

  static async fetchPrivateCollectionsForScore(...externalIds: string[]): Promise<number[]> {
    const [resp] = await http.post(ApiRoutes.apiScoresPrivateCollectionsPath(), {
      score_ids: externalIds,
    })
    if (!resp?.data) return []
    return resp.data
  }
}
